// Google Analytics 4 helper functions
// Measurement ID: G-MR8E42JC7K
// Google Ads ID: AW-18381203085 (Purchase conversion label: uuITCPKY_-EcEI3N67xE)

export const GA_MEASUREMENT_ID = 'G-MR8E42JC7K'
export const GOOGLE_ADS_ID = 'AW-18381203085'
export const GOOGLE_ADS_CONVERSION_LABEL = 'uuITCPKY_-EcEI3N67xE'

// Returns the gtag function, bootstrapping the dataLayer shim if needed.
// Events are queued in dataLayer and replayed when the real gtag.js loads
// (see components/analytics/DeferredGtag.js).
function getGtag() {
    if (typeof window === 'undefined') return null
    window.dataLayer = window.dataLayer || []
    if (!window.gtag) {
        window.gtag = function gtag() { window.dataLayer.push(arguments) }
    }
    return window.gtag
}

// Log a GA4 event (safe to call even if gtag hasn't loaded yet)
export function trackEvent(eventName, params = {}) {
    const gtag = getGtag()
    if (gtag) gtag('event', eventName, params)
}

// Fire a Google Ads conversion. Generates a unique transaction_id if none provided
// so Google Ads can de-duplicate (e.g. if the same event fires twice).
export function trackGoogleAdsConversion(transactionId = '') {
    const gtag = getGtag()
    if (!gtag) return
    const tid = transactionId || `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    gtag('event', 'conversion', {
        send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`,
        transaction_id: tid,
    })
}

// Track phone call click — also fires the Google Ads Purchase conversion
// (reusing the Purchase label per current setup; see reporting caveat in docs).
export function trackPhoneClick(location = 'unknown') {
    trackEvent('phone_call_click', {
        event_category: 'engagement',
        event_label: location,
        link_url: 'tel:click',
    })
    trackGoogleAdsConversion()
}

// Track quote form submission
export function trackQuoteSubmit(vehicleInfo = {}) {
    trackEvent('quote_submit', {
        event_category: 'conversion',
        vehicle_make: vehicleInfo.make || '',
        vehicle_model: vehicleInfo.model || '',
        vehicle_year: vehicleInfo.year || '',
        vehicle_condition: vehicleInfo.condition || '',
        suburb: vehicleInfo.suburb || '',
    })
}
